import { render, staticRenderFns } from "./BoxwrapContents.vue?vue&type=template&id=279bd7a0"
import script from "./BoxwrapContents.vue?vue&type=script&lang=js"
export * from "./BoxwrapContents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports